/**
 * The one documented keyboard shortcut of the app: Ctrl/Cmd + Shift + `.`.
 * Matches on `code`, not `key`, so it is layout-independent (Shift changes the
 * `key` of the period on most layouts). On `/login` it toggles the Tahiti
 * encart; elsewhere it opens the settings page.
 */
export function isSettingsShortcut(event: KeyboardEvent): boolean {
  return (event.ctrlKey || event.metaKey) && event.shiftKey && event.code === 'Period';
}
